import { render, staticRenderFns } from "./dashboard-table-view.vue?vue&type=template&id=c20d9920&"
import script from "./dashboard-table-view.vue?vue&type=script&lang=ts&"
export * from "./dashboard-table-view.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-table-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports